import { render, staticRenderFns } from "./BackgroundPanel.vue?vue&type=template&id=193f6d28&scoped=true&"
import script from "./BackgroundPanel.vue?vue&type=script&lang=js&"
export * from "./BackgroundPanel.vue?vue&type=script&lang=js&"
import style0 from "./BackgroundPanel.vue?vue&type=style&index=0&id=193f6d28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "193f6d28",
  null
  
)

export default component.exports